<div fxLayout="column" fxFlexFill>
   <!-- templates -->
   <div class="sam-form-flex-row">
      <div class="sam-form-flex-row sam-margin-right-medium" style="width: 50%">
         <fa-icon class="sam-center sam-margin" style="width: 1em" [icon]="fileIcon" [fixedWidth]="true"></fa-icon>

         <kendo-dropdownlist
            class="k-form-field sam-form-control sam-form-control-full-width sam-center"
            [data]="filteredSelectableTemplates$ | async"
            [filterable]="false"
            [textField]="'name'"
            [valueField]="'id'"
            [value]="selectedTemplate$ | async"
            [loading]="isLoadingTemplates$ | async"
            (valueChange)="selectTemplate($event)"
         >
            <ng-template kendoDropDownListValueTemplate let-dataItem>
               {{ dataItem?.name }}
            </ng-template>
            <ng-template kendoDropDownListItemTemplate let-dataItem>
               <div class="sam-form-row" style="margin-bottom: 0">
                  <div>
                     {{ dataItem?.name }}
                  </div>
                  <div class="sam-sub-font-size">
                     <div style="opacity: 0.6" class="sam-sub-font-size">
                        {{ dataItem?.from | translateCallTag }}
                     </div>
                  </div>
               </div>
            </ng-template>

            <ng-template kendoDropDownListNoDataTemplate>
               <h4>
                  <fa-icon [icon]="noDataIcon"></fa-icon><br /><br />
                  {{ 'samwin.email_dialog.no_templates_available' | translate }}
               </h4>
            </ng-template>
         </kendo-dropdownlist>
      </div>
      <div class="sam-center sam-form-flex-row sam-margin-left sam-resizeable">
         <fa-icon [icon]="userIcon" [fixedWidth]="true"></fa-icon>
         <samweb-text-with-overflow-tooltip style="opacity: 0.6" [value]="(email$ | async).from" class="sam-resizeable">
         </samweb-text-with-overflow-tooltip>
      </div>

      <div class="sam-form-flex-row" style="align-items: end; flex: auto">
         <div style="flex: auto"></div>
         <button
            kendoButton
            [look]="'flat'"
            [primary]="isCcShown"
            (click)="onToggleCc()"
            class="cc sam-center attachment-toggle"
            [disabled]="isCcShown && !(isCcEmpty$ | async)"
         >
            {{ 'samwin.email_dialog.cc' | translate }}
         </button>
         <button
            kendoButton
            [look]="'flat'"
            [primary]="isBccShown"
            (click)="onToggleBcc()"
            class="bcc sam-center attachment-toggle"
            [disabled]="isBccShown && !(isBccEmpty$ | async)"
         >
            {{ 'samwin.email_dialog.bcc' | translate }}
         </button>
         <button
            class="sam-center attachment-toggle"
            style="padding-left: 0.4em"
            kendoButton
            [look]="'flat'"
            [primary]="isAttachmentShown"
            (click)="onToggleAttachments()"
            [disabled]="isAttachmentShown && (attachments$ | async).length > 0"
         >
            <fa-icon [icon]="uploadIcon"></fa-icon><br /><br />
         </button>
      </div>
   </div>

   <!-- Email data -->
   <samweb-email-multiselect
      style="flex: auto"
      [icon]="usersIcon"
      [header]="'samwin.email_dialog.to'"
      [showWarning]="(isToInvalid$ | async) && (isValidationEnabled$ | async)"
      [autocompleteMatches]="autocompleteMatches$ | async"
      [selectedEntries]="recipientTo$ | async"
      (valueChangedDebounced)="updateMultiselectSearchValue($event)"
      (entrySelected)="onEntrySelected($event, 'to')"
   >
   </samweb-email-multiselect>

   <samweb-email-multiselect
      *ngIf="isCcShown"
      [icon]="usersIcon"
      [swapIconOpacity]="true"
      [header]="'samwin.email_dialog.cc'"
      [autocompleteMatches]="autocompleteMatches$ | async"
      [selectedEntries]="recipientCc$ | async"
      (valueChangedDebounced)="updateMultiselectSearchValue($event)"
      (entrySelected)="onEntrySelected($event, 'cc')"
   >
   </samweb-email-multiselect>

   <samweb-email-multiselect
      *ngIf="isBccShown"
      [icon]="usersIcon"
      [fadeIconOpacity]="true"
      [header]="'samwin.email_dialog.bcc'"
      [autocompleteMatches]="autocompleteMatches$ | async"
      [selectedEntries]="recipientBcc$ | async"
      (valueChangedDebounced)="updateMultiselectSearchValue($event)"
      (entrySelected)="onEntrySelected($event, 'bcc')"
   >
   </samweb-email-multiselect>

   <samweb-input-field
      style="flex: auto"
      [icon]="clipBoardIcon"
      [header]="'samwin.email_dialog.subject'"
      [value]="(email$ | async).subject"
      [showWarning]="(isSubjectInvalid$ | async) && (isValidationEnabled$ | async)"
      (valueChangedDebounced)="textChanged($event, 'subject')"
   ></samweb-input-field>

   <!-- attachments -->
   <samweb-attachment-upload-bar
      *ngIf="isAttachmentShown"
      [isInvalid]="isMessageSizeLimitReached$ | async"
      [attachments]="attachments$ | async"
      [messageId]="messageId"
      (uploadCanceled)="attachmentUploadCanceled($event)"
   ></samweb-attachment-upload-bar>

   <!-- Editor inclusive body -->
   <samweb-text-editor
      class="text-editor"
      [value]="emailContent$ | async"
      (valueChange)="textChanged($event, 'body')"
   ></samweb-text-editor>

   <!-- Bottom button bar missed call -->
   <div *ngIf="!(hasReferenceMail$ | async)" class="sam-form-flex-row" style="width: 100%; align-items: baseline">
      <div>
         <div
            class="k-block k-bg-warning sam-center"
            fxFlex="1 1 auto"
            *ngIf="!(isValidated$ | async) && ((isValidationEnabled$ | async) || (isMessageSizeLimitReached$ | async))"
            [innerHTML]="inValidMessage$ | async"
         ></div>
      </div>
      <div fxFlex="1 1 auto"></div>

      <div class="sam-form-row sam-margin-left" style="float: right; margin-bottom: 0; align-self: flex-end">
         <button
            style="min-width: 5em"
            kendoButton
            (click)="onSend()"
            primary="true"
            [disabled]="
               !(isValidated$ | async) && ((isValidationEnabled$ | async) || (isMessageSizeLimitReached$ | async))
            "
         >
            {{ 'common.send' | translate }}
         </button>
      </div>
   </div>

   <!-- Bottom button bar for forwarding and replying -->
   <div *ngIf="hasReferenceMail$ | async" class="sam-form-flex-row" style="width: 100%; align-items: baseline">
      <div>
         <div
            class="k-block k-bg-warning sam-center"
            fxFlex="1 1 auto"
            *ngIf="!(isValidated$ | async) && ((isValidationEnabled$ | async) || (isMessageSizeLimitReached$ | async))"
            [innerHTML]="inValidMessage$ | async"
         ></div>
      </div>
      <div fxFlex="1 1 auto"></div>
      <div *samwebVar="messageInfo$ | async as messageInfo" class="sam-form-flex-row">
         <samweb-email-category
            class="sam-full-height sam-display-contents"
            [isInbox]="true"
            [messageInfo]="messageInfo"
         ></samweb-email-category>
         <div class="sam-form-row sam-margin-left" style="float: right; margin-bottom: 0; align-self: flex-end">
            <button
               kendoButton
               (click)="onSendAndComplete(messageInfo)"
               primary="true"
               [disabled]="
                  !(isValidated$ | async) && ((isValidationEnabled$ | async) || (isMessageSizeLimitReached$ | async))
               "
            >
               {{ 'samwin.email_dialog.send_and_complete' | translate }}
            </button>
         </div>
         <div class="sam-form-row sam-margin-left" style="float: right; margin-bottom: 0; align-self: flex-end">
            <button
               kendoButton
               (click)="onSendAndTrack(messageInfo)"
               primary="true"
               [disabled]="
                  !(isValidated$ | async) && ((isValidationEnabled$ | async) || (isMessageSizeLimitReached$ | async))
               "
            >
               {{ 'samwin.email_dialog.send_and_track' | translate }}
            </button>
         </div>
      </div>
      <div class="sam-form-row sam-margin-left" style="float: right; margin-bottom: 0; align-self: flex-end">
         <button style="min-width: 5em" kendoButton (click)="onCancel()">
            {{ 'common.cancel' | translate }}
         </button>
      </div>
   </div>
</div>
